import {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useMemo,
  useRef,
} from "react";
// import { Command } from "cmdk";
import type {
  SuggestionKeyDownProps,
  SuggestionProps,
} from "@tiptap/suggestion";
import {
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
} from "src/components/ui/command";



/**
 * A tiny outlet that TipTap mounts inside tippy.
 * It renders the list of items with cmdk so we get:
 *   – arrow‑key navigation
 *   – Enter to select
 *   – automatic ARIA attributes
 *
 * It matches the API the slash menu expects, so both
 * extensions share the same UX.
 */
const CommandTunnelOutlet = forwardRef<
  { onKeyDown: (props: SuggestionKeyDownProps) => boolean },
  SuggestionProps<string>
>((props, ref) => {
  const { items, command } = props;
  const listRef = useRef<HTMLDivElement | null>(null);
  const inputRef = useRef<HTMLInputElement | null>(null);

  /* Expose onKeyDown so TipTap can forward keyboard events */
  useImperativeHandle(ref, () => ({
    // onKeyDown: ({ event }: SuggestionKeyDownProps) => {
    //   // Let cmdk handle ArrowUp / ArrowDown / Enter.
    //   // Return false to signal "not handled" for other keys.
    //   const keys = ["ArrowUp", "ArrowDown", "Enter"];
    //   return keys.includes(event.key);
    // },
    onKeyDown: ({ event }) => {
      if (!listRef.current) return false;

      const clone = new KeyboardEvent("keydown", {
        key: event.key,
        code: event.code,
        keyCode: event.keyCode,
        which: event.which,
        bubbles: true,
      });
      listRef.current.dispatchEvent(clone);

      // let TipTap know we handled it so the original event
      // doesn’t reach the editor (prevents stray newlines)
      return ["ArrowUp", "ArrowDown", "Enter", "Tab"].includes(event.key);
    },
  }));

  /* Auto‑focus the cmdk container when it mounts so arrow keys work */
  // useEffect(() => {
  //   // listRef.current?.focus();
  //   console.log(inputRef.current);
  //   inputRef.current?.focus();
  // }, []);


  return (
    <Command
      ref={listRef}
      tabIndex={-1} /* we manage focus manually */
      loop
      label="Variable menu"
      className="max-h-60 min-w-[200px] overflow-auto rounded-md border bg-white"
    >
      {/* <CommandInput ref={inputRef} autoFocus placeholder="Search..." /> */}
      <CommandList>
        
            {items.map((item) => (
              <CommandItem
                key={item}
                value={item}
                onSelect={() => command(item)}
                className="cursor-pointer rounded px-2 py-1 text-sm aria-selected:bg-gray-100"
              >
                {item}
              </CommandItem>
            ))}
      </CommandList>
    </Command>
  );
});

CommandTunnelOutlet.displayName = "CommandTunnelOutlet";

export default CommandTunnelOutlet;
